export * from './errorPage.component'
